import { render, staticRenderFns } from "./ZonasModalEdicion.vue?vue&type=template&id=501ea25e&scoped=true&"
import script from "./ZonasModalEdicion.vue?vue&type=script&lang=ts&"
export * from "./ZonasModalEdicion.vue?vue&type=script&lang=ts&"
import style0 from "./ZonasModalEdicion.vue?vue&type=style&index=0&id=501ea25e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501ea25e",
  null
  
)

export default component.exports